export default __webpack_public_path__ + "static/media/section5Mobile.f11fc2ee.png";